import { useUserData } from '@ox-technologies/auth';
import { CUSTOM_AUTH_TOKEN } from 'config';

// Every consumer of the signed-in user paired `useUserData` with the same
// CUSTOM_AUTH_TOKEN import. Wrapping it keeps that wiring in one place.
export const useCurrentUser = () => useUserData(CUSTOM_AUTH_TOKEN);
